import ScrollContainer from "react-indiana-drag-scroll"
import { Header } from "./tabHeader"
import { PropTypes } from 'prop-types';

const TabHeaders = ({headers,activeTab,className,handleTabClick}) => {
    return (
        <div className="flex w-full items-center justify-center">
            <ScrollContainer horizontal className="flex gap-3 lg:gap-5   scroll-smooth snap-mandatory snap-x overflow-x-auto lg:scroll-px-3 " role="tablist">
                {headers?.map((header, index) => (
                    <Header
                        key={index}
                        text={header}
                        className={className}
                        isActive={index === activeTab}
                        onClick={() => handleTabClick(index)}
                    />
                ))}
            </ScrollContainer>
        </div>
    )
}
TabHeaders.propTypes = {
    headers: PropTypes.array,
    activeTab: PropTypes.number,
    handleTabClick: PropTypes.func,
}
export default TabHeaders